import React from 'react';

import TickIcon from 'icons/ic-tick.svg';
import { Trans } from 'react-i18next';

import Toast from 'components/application/Toast';

import { useCurrentActor } from 'components/contexts/CurrentActor';
import { useBreadBoard } from 'components/contexts/Toaster';

export default function ProjectPersonnelRemovedToast({
  displayName,
  toastKey,
}) {
  const breadBoard = useBreadBoard();

  const {
    division: {
      attributes: { singularRAMSName },
    },
  } = useCurrentActor();

  return (
    <Toast
      burn={breadBoard.handleBurnToast}
      burnTimer={8000}
      contents={
        <>
          <div className='toast__icon tw-bg-green-500'>
            <TickIcon
              className='[&_polygon]:tw-fill-white'
              height={20}
              width={20}
            />
          </div>
          <div className='toast__text'>
            <Trans
              i18nKey='projectPersonnel.components.ProjectPersonnelRemovedToast.description'
              ns='components'
              tOptions={{ interpolation: { escapeValue: false } }}
              values={{ displayName, singularRAMSName }}
            />
          </div>
        </>
      }
      modifiers='no-undo'
      toastKey={toastKey}
    />
  );
}
